import React from 'react';
import Reveal from './Reveal';

const STEPS = [
  { n: '01', t: 'Prompt', d: 'Describe the line: product, volumes, constraints.' },
  { n: '02', t: 'Factory Layout', d: 'Dimensioned 3D floor plan — stations, conveyors, safety zones.' },
  { n: '03', t: 'Plan & Simulate', d: 'Line balancing, shift schedules, throughput simulation.' },
  { n: '04', t: 'Robot Programs', d: 'The agent authors the cell programs on real kinematics.' },
  { n: '05', t: 'Verification', d: 'Every program proven against the kinematic oracle.' },
  { n: '06', t: 'Optimization', d: 'Cycle-time variants compared, re-verified, applied.' },
  { n: '07', t: 'Deploy', d: 'Vendor-native code and files your floor recognizes.' },
];

const PipelineSection = () => (
  <section id="pipeline" className="py-28 bg-white dark:bg-black">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="font-mono text-xs tracking-[0.25em] uppercase text-emerald-600 dark:text-emerald-400 mb-4">01 — The pipeline</div>
        <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight text-gray-900 dark:text-white mb-6 max-w-3xl">
          Spec to factory in one closed loop
        </h2>
        <p className="text-lg sm:text-xl text-gray-600 dark:text-gray-400 max-w-2xl mb-16">
          Most of what hardware costs isn't physics — it's coordination. The
          Factory Agent closes the loop that humans currently glue together.
        </p>
      </Reveal>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-7 gap-px bg-black/10 dark:bg-white/10 border border-black/10 dark:border-white/10">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 60} className="bg-white dark:bg-black">
            <div className="p-6 h-full min-h-[180px] flex flex-col hover:bg-black/[0.03] dark:hover:bg-white/[0.03] transition-colors duration-300">
              <div className="font-mono text-sm text-emerald-600 dark:text-emerald-400 mb-4">{s.n}</div>
              <div className="font-semibold text-gray-900 dark:text-white text-lg mb-2 leading-snug">{s.t}</div>
              <div className="text-sm text-gray-500 leading-relaxed">{s.d}</div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default PipelineSection;
